var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2605 1.99958C7.17052 1.85958 3.00052 5.94958 3.00052 10.9996H1.21052C0.760519 10.9996 0.540519 11.5396 0.860519 11.8496L3.65052 14.6496C3.85052 14.8496 4.16052 14.8496 4.36052 14.6496L7.15052 11.8496C7.21962 11.7791 7.26631 11.6897 7.2847 11.5927C7.30309 11.4957 7.29236 11.3955 7.25386 11.3046C7.21537 11.2137 7.15082 11.1362 7.06837 11.0819C6.98591 11.0277 6.88923 10.999 6.79052 10.9996H5.00052C5.00052 7.09958 8.18052 3.94958 12.1005 3.99958C15.8205 4.04958 18.9505 7.17958 19.0005 10.8996C19.0505 14.8096 15.9005 17.9996 12.0005 17.9996C10.3905 17.9996 8.90052 17.4496 7.72052 16.5196C7.52898 16.3687 7.28867 16.2935 7.04529 16.3082C6.8019 16.323 6.57243 16.4267 6.40052 16.5996C5.98052 17.0196 6.01052 17.7296 6.48052 18.0896C8.05164 19.3321 9.99749 20.0053 12.0005 19.9996C17.0505 19.9996 21.1405 15.8296 21.0005 10.7396C20.8705 6.04958 16.9505 2.12958 12.2605 1.99958ZM11.7505 6.99958C11.3405 6.99958 11.0005 7.33958 11.0005 7.74958V11.4296C11.0005 11.7796 11.1905 12.1096 11.4905 12.2896L14.6105 14.1396C14.9705 14.3496 15.4305 14.2296 15.6405 13.8796C15.8505 13.5196 15.7305 13.0596 15.3805 12.8496L12.5005 11.1396V7.73958C12.5005 7.33958 12.1605 6.99958 11.7505 6.99958Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.660c004de3f0e3d99d1f65bb9b4a6ef2.svg";
export { ForwardRef as ReactComponent };